import * as types from './types'

export default {
  [types.SET_LOADING] (state, payload) {
    state.loading = payload
  }
}
